/* eslint-disable max-len */
/**
 * Greek translations.
 */
export default {
  ACTION: {
    CANCEL: 'Ακύρωση',
    CONFIRM: 'Επιβεβαίωση',
    SAVE: 'Αποθήκευση'
  },
  ERROR: {},
  HEADER: {
    LINK: 'Σύνδεσμος',
    SOCIAL_NETWORK: 'Κοινωνική δικτύωση',
    USERNAME: 'Όνομα χρήστη'
  },
  LABEL: {
    CREATE_LINK: 'Προσθήκη κοινωνικού δικτύου',
    EDIT_LINK: 'Επεξεργασία κοινωνικού δικτύου',
    INACTIVATE_LINK: 'Διαγραφή κοινωνικού δικτύου',
    INACTIVATE_LINK_MODAL_TITLE: 'Διαγραφή κοινωνικού δικτύου',
    LINK: 'Σύνδεσμος',
    SOCIAL_NETWORK: 'Κοινωνική δικτύωση',
    USERNAME: 'Όνομα χρήστη'
  },
  SENTENCE: {
    ERROR: 'Σφάλμα',
    INACTIVATE_LINK_TEXT:
      'Είστε σίγουροι ότι θέλετε να διαγράψετε το κοινωνικό δίκτυο;',
    NO_ROWS_LINKS: 'Δεν υπάρχουν μέσα κοινωνικής δικτύωσης'
  },
  SUCCESS: {
    LINKS_DETAILS_INACTIVATE: 'Το κοινωνικό δίκτυο εξαλείφθηκε με επιτυχία',
    LINKS_DETAILS_SAVED: 'Το κοινωνικό δίκτυο αποθηκεύτηκε με επιτυχία',
    LINKS_DETAILS_UPDATED: 'Κοινωνικό δίκτυο ενημερώθηκε με επιτυχία',
    SUCCESS: 'Επιτυχία'
  },
  TOOLTIP: {
    LINK: 'Σύνδεσμος',
    SOCIAL_NETWORK: 'Κοινωνική δικτύωση',
    USERNAME: 'Όνομα χρήστη'
  }
};
